// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__2p620"};